import { Photo, Section, SectionHeading } from "@/components/ui";
import { MOMENTS, PHOTOS } from "@/data/photos";

/**
 * "Moments of Growth": an endless, gap-free slider of real programme photos.
 * The list is rendered twice and the track slides left by exactly one list (-50%), so it loops with no pause.
 * The second copy is hidden from assistive tech. With reduced motion the track stands still and can be scrolled by hand.
 */
export function MomentsSection() {
  const loop = [0, 1];

  return (
    <Section labelledBy="moments-title" testId="home-moments">
      <SectionHeading id="moments-title" title={MOMENTS.title} highlight={MOMENTS.highlight} />

      <div className="relative left-1/2 mt-8 w-screen -translate-x-1/2 overflow-hidden motion-reduce:overflow-x-auto" data-testid="moments-slider">
        <div className="flex w-max animate-marquee motion-reduce:animate-none">
          {loop.map((copy) => (
            <ul key={copy} className="flex shrink-0" aria-hidden={copy === 1 ? "true" : undefined}>
              {MOMENTS.photos.map((key) => (
                <li key={key} className="w-52 shrink-0 pr-3 sm:w-60 sm:pr-4 lg:w-72">
                  <Photo
                    photo={copy === 1 ? { ...PHOTOS[key], alt: "" } : PHOTOS[key]}
                    ratio="aspect-[3/4]"
                    priority
                    sizes="(min-width: 1024px) 288px, 240px"
                  />
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </Section>
  );
}
